import {attributes} from "./overview-filter-constants";
import {deleteSearchParam, trySaveToUrl} from "./overview-filter-state";
import {executeOnCaptchaSuccess} from "./captcha-handler";
import {trackVacancySearchAlertSuccess} from "./google-tag-manager";

const classesValidationMessageInvalid = [
	"invalid-feedback",
	"mt-1",
	"d-block",
	"errorMessage",
];
const classesFieldInValid = ["is-invalid", "error"];
let formEnabled = true;

const getPopupElement = (popup) =>
	document.querySelector(`[${attributes.alertPopup}=${popup}]`);

const prefillPopupContent = () => {
	const jobAlertLocation = document.querySelector("#job-alert-location");
	const jobAlertSearchTerm = document.querySelector("#job-alert-term");
	const jobAlertRadius = document.querySelector("#job-alert-radius");

	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);

	if (urlParams.has("Location")) {
		jobAlertLocation.value = urlParams.get("Location");
	}
	if (urlParams.has("SearchTerm")) {
		jobAlertSearchTerm.value = urlParams.get("SearchTerm");
	}
	if (urlParams.has("Radius")) {
		jobAlertRadius.value = urlParams.get("Radius");
	}
};

const prefill = () => {
	const inputsToFill = document.querySelectorAll(
		`[${attributes.alertFieldForFilter}]`
	);
	inputsToFill.forEach((input) => {
		const filter = input.attributes[attributes.alertFieldForFilter].value;
		const source = document.querySelector(`[data-filter-name=${filter}]`);
		input.value = source.value;
	});
};

const setOpen = (popup, open) => {
	prefillPopupContent();
	const element = getPopupElement(popup);

	if (open) {
		prefill();
		showStep(popup, "form");

		element.style.display = "block";
		trapFocus(element);
		document.body.classList.add("dg-body-no-scroll");
	} else {
		element.style.display = "none";
		document.body.classList.remove("dg-body-no-scroll");
	}
};

const getFocusableElements = (element) => {
	const focusableEls = element.querySelectorAll(".dg-modal-focus-item");

	return [...focusableEls].filter((focusableEl) => {
		if (focusableEl.hasAttribute("disabled")) {
			return false;
		}

		const style = window.getComputedStyle(focusableEl);
		return focusableEl.getClientRects().length > 0 && style.visibility !== "hidden";
	});
};

const trapFocus = (element) => {
	const focusableEls = getFocusableElements(element);
	if (!focusableEls.length) {
		return;
	}
	focusableEls[0].focus(element);

	if (element.dataset.focusTrapBound === "true") {
		return;
	}

	element.addEventListener("keydown", function (e) {
		const isTabPressed = e.key === "Tab";
		if (!isTabPressed) {
			return;
		}

		const focusableEls = getFocusableElements(element);
		if (!focusableEls.length) {
			return;
		}

		const firstFocusableEl = focusableEls[0];
		const lastFocusableEl = focusableEls[focusableEls.length - 1];

		if (e.shiftKey) {
			if (document.activeElement === firstFocusableEl) {
				e.preventDefault();
				lastFocusableEl.focus();
			}
		} else if (document.activeElement === lastFocusableEl && element.contains(lastFocusableEl)) {
			e.preventDefault();
			firstFocusableEl.focus();
		}
	});

	element.dataset.focusTrapBound = "true";
};

const elementsToValidate = ["Term", "Location", "Email", "ReCaptcha"];

const showValidationMessage = (validationMessageElement, message) => {
	if (validationMessageElement) {
		validationMessageElement.innerHTML = message;
		validationMessageElement.classList.add(
			...classesValidationMessageInvalid
		);
	}

	const fieldName = validationMessageElement.attributes["data-valmsg-for"].value;
	const field =
		document.querySelector(`[name=${fieldName}]`) ||
		document.getElementById(fieldName);
	if (field) {
		field.classList.add(...classesFieldInValid);
	}
};

const resetValidationMessage = (validationMessageElements) => {
	validationMessageElements.forEach(validationMessageElement => {
		validationMessageElement.classList.remove(
			...classesValidationMessageInvalid
		);
		validationMessageElement.innerHTML = "";

		const fields = document.querySelectorAll(`[name="${validationMessageElement.dataset.valmsgFor}"]`);
		fields.forEach(field => field.classList.remove(...classesFieldInValid))
	});
};

const removeValidationErrors = () => {
	const validationMessages = Array.from(document.querySelectorAll("[data-valmsg-for]"));
	const elementsToValidate = validationMessages.map(elem => elem.dataset.valmsgFor);

	elementsToValidate.forEach((propertyName) => {
		const validation = document.querySelectorAll(
			`[data-valmsg-for="${propertyName}"]`
		);
		resetValidationMessage(validation);
	});
};

const disableSubmitButton = (disable) => {
	const submitButton = document.getElementById("job-alert-submit");
	if (disable) {
		submitButton.setAttribute("disabled", "true");
	} else {
		submitButton.removeAttribute("disabled");
	}
};

const addValidationErrors = (errors) => {
	errors.forEach((error) => {
		if (!elementsToValidate.includes(error.propertyName)) {
			return;
		}

		const validationMessages = document.querySelectorAll(
			`[data-valmsg-for="${error.propertyName}"]`
		);

		validationMessages.forEach((validation) => {
			showValidationMessage(validation, error.errorMessage);
		});
	});
};

const addGenericError = () => {
	const genericError = document.querySelector("#generic-error");
	showValidationMessage(
		genericError,
		genericError.attributes["val-msg-generic"].value
	);
};

const handleFormSubmit = async (event) => {
	const form = event.target.closest("form");

	removeValidationErrors();

	disableSubmitButton(true);

	const hasCaptcha = form.querySelectorAll('#google-recaptcha-placeholder').length > 0;

	if (hasCaptcha) {
		executeOnCaptchaSuccess(async () => {
			await sendAlert(form);
		});
	} else {
		await sendAlert(form);
	}
};

async function sendAlert(form) {
	const action = form.action;
	const method = form.method;

	try {
		const formData = new FormData(form);

		const response = await fetch(action, {
			method,
			body: formData,
		});

		if (response.ok) {
			trackVacancySearchAlertSuccess(formData);
			disableSubmitButton(false);

			if (form.dataset.popup) {
				showStep(form.dataset.popup, "success");

				return;
			} else {
				form.classList.add("d-none");
				document
					.getElementById("job-alert-success-message")
					.classList.remove("d-none");
				return;
			}
		}

		const errorResponse = await response.json();
		const validationErrors = JSON.parse(errorResponse.detail);
		addValidationErrors(validationErrors);
		disableSubmitButton(false);
	} catch (error) {
		addGenericError();
		disableSubmitButton(false);
	}
}

const showStep = (popup, step) => {
	const popupElement = getPopupElement(popup);

	const formStepElements = popupElement.querySelectorAll("[data-step=form]");
	const successStepElements = popupElement.querySelectorAll("[data-step=success]");

	if (step === "success") {
		formStepElements.forEach(element => {
			element.classList.add("tw-hidden")
		});
		successStepElements.forEach(element => {
			element.classList.remove("tw-hidden")
		});
	} else {
		formStepElements.forEach(element => {
			element.classList.remove("tw-hidden")
		});
		successStepElements.forEach(element => {
			element.classList.add("tw-hidden")
		});
	}
}

const handleDirectOpen = (popup) => {
	const params = new URLSearchParams(window.location.search);
	if (params.has("alert")) {
		setOpen(popup, true);
		deleteSearchParam("alert");
		trySaveToUrl(false);
	}
};

const bindPopup = (openButtonAttribute, popup) => {
	const openButtons = document.querySelectorAll(`[${openButtonAttribute}]`);

	openButtons.forEach((button) => {
		button.addEventListener("click", () => setOpen(popup, true));
	});

	const element = getPopupElement(popup);
	const closeButtons = element.querySelectorAll(
		`[${attributes.alertPopupClose}]`
	);
	closeButtons.forEach((button) => {
		button.addEventListener("click", (event) => {
			event.preventDefault();
			setOpen(popup, false);
		});
	});

	document.addEventListener("keydown", (event) => {
		if (event.key === "Escape") setOpen(popup, false);
	});

	handleDirectOpen(popup);
};

export const bindJobAlertPopup = () => {
	const form = document.getElementById("jobalert-form");

	if (form.dataset.popup)
		bindPopup("data-open-button-alert", form.dataset.popup);

	disableSubmitButton(false);
};

export const bindJobAlertSubmit = () => {
	const button = document.getElementById("job-alert-submit");
	button.addEventListener("click", handleFormSubmit);
};
